// Persisted desktop sidebar pin state, shared by the live sidebar and the
// skeleton loaders so a reload renders the same width before tabs arrive.
const SIDEBAR_COLLAPSED_KEY = "emalpha.sidebarCollapsed";

export const readSidebarCollapsed = () => {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "1";
  } catch {
    return false;
  }
};

export const writeSidebarCollapsed = (collapsed) => {
  try {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? "1" : "0");
  } catch {
    // Storage unavailable (private mode); pin state just won't persist.
  }
};
